import React, { useState, useEffect } from 'react';
import { Alert, Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { Add, Close, CreditCardOutlined } from '@material-ui/icons';
import DatePicker from 'react-datepicker';
import { Currency, currencyReverse } from 'helpers/Currency';

import "./style.scss";
import { api } from 'services';
import Select from 'react-select';
import { filter } from 'bluebird';
import MyLoadStyle from './MyLoadStyle';

const CreditCardFormRevenues = ({
  list,
  listSelected,
  onChange,
  filters,
  setFilters,
  close,
  card,
  listYear
}) => {

  const [showModalCurrecy, setShowModalCurrency] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [tasksSelected, setTasksSelected] = useState([]);
  const [year, setYear] = useState(filters.year);
  const [last, setLast] = useState(null);

  useEffect(()=>{
    api
      .get('task-groups/list-for-event-and-action')
      .then(({ data }) => setTasks(data));
  },[]);

  useEffect(()=>{
    setFilters({...filters, task_id: tasksSelected.map(a=>(a.value))});
  },[tasksSelected]);

  useEffect(()=>{
    if(last != null){
      let aux = document.getElementById("revenues-itens-"+last+"-selected");
      aux.scrollIntoView();
      aux.className += " new-itens-revenues";
    }
  },[last]);

  const currencyFormat = (value, currency) => {
    switch (currency) {
      case 2:
        return parseFloat(value).toLocaleString('en-US',{style:'currency',currency:'USD'});
      case 3:
        return parseFloat(value).toLocaleString('de-DE',{style:'currency',currency:'EUR'}); 
      default:
        return parseFloat(value).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
    }
  }

  const renderList = (list, selected) => {
    if(!selected){
      list = list.filter((d)=>{
        let has = listSelected.filter((d2)=>{
          return d.id == d2.id && d.type == d2.type; 
        }).length > 0;
        return !has;
      });
    }
    const getMessage = (d) => {
      if(d.parent_type == 'Ação'){
        return `Local: Ação #${d.parent_id} - ${d.parent_name}`;
      } else {
        return `Local: Evento #${d.parent_id} - ${d.parent_name}`;
      }
    }

    return <>
    {list.map((d,k)=>{
      return <div key={k} className="revenues-itens" id={"revenues-itens-"+k+"-"+(selected?"selected":"")} style={{opacity:(selected && k == list.length-1 && last?"0":"1")}}>
        <div className="revenues-itens-head row justify-content-between m-0">
          <div className="col p-0 m-0 align-self-center">
            {`${d.type} #${d.id}`}
          </div>
          <div className="col-auto p-0 m-0 align-self-center">
            {selected?(<>
            {close?'':(<div style={{background:'red', borderRadius:'0.3rem', color:"white"}}>
              <Close onClick={()=>{
                if(onChange){
                  let list_aux = listSelected.filter((d2)=>{
                    return d.id != d2.id || d.type != d2.type; 
                  });
                  onChange([...list_aux]);
                  setLast(null);
                }
              }}/>
            </div>
            )}</>):
            <div style={{background:'lawngreen', borderRadius:'0.3rem', color:"white"}}>
              <Add onClick={()=>{
                if(d.currency != 1) {
                  setShowModalCurrency(d);
                  return;
                }
                if(onChange){
                  onChange([...listSelected, d]);
                  setLast(listSelected.length);
                }
              }} />
            </div>
            }
          </div>
        </div>
        <div className="revenues-itens-body">
          <div className="row m-0">
            <div className="col p-1">
              <div>{d.service_provider}</div>
              <div>{d.description}</div>
            </div>
            <div className='col-auto'>
              <div className="align-self-center revenues-itens-currency pr-1">
              Reembolsável
                <div>{currencyFormat(d.value, d.currency)}</div>
                {d.realValue?(
                  <div>{currencyFormat(d.realValue, 1)}</div>
                ):''}
              </div>
              <div className="align-self-center revenues-itens-currency pr-1 pt-1">
              Não Reembolsável
                <div>{currencyFormat(d.non_refundable, d.currency)}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="revenues-itens-footer">
          {getMessage(d)}
        </div>
      </div>;
    })}
    </>;
  }

  const renderLeft = (list) => {
    let data = list.data.filter((d)=>{
      let has = listSelected.filter((d2)=>{
        return d.id == d2.id && d.type == d2.type; 
      }).length > 0;
      return !has;
    });
    return <>
      <div id="revenues-area-left" className="revenues-area-all">
        <div className="revenues-area-head row m-0 p-0">
          <div className="col align-self-center">
            Quantidade de itens: {data.length}
          </div>
        </div>
        <div className="area">
          {list.load?
          <Row className="justify-content-center m-0"><Col xs="auto">
            <MyLoadStyle/>
          </Col></Row>
          : (
            data.length > 0?
              renderList(data)
            :
            <Row className="justify-content-center m-0"><Col xs="auto">
              Sem dados para mostrar
            </Col></Row>
          )}
        </div>
      </div>
    </>;
  }

  const renderRight = (list = []) => {
    let total = 0;
    list.forEach(a=>(total += a.realValue?a.realValue:a.value));
    return <>
      <div id="revenues-area-right" className={"revenues-area-all"+(close?" revenues-area-close":"")}>
        <div className="revenues-area-head row m-0 p-0">
          <div className="col align-self-center">
            Total: {parseFloat(total).toLocaleString("pt-BR",{style:"currency",currency:"BRL"})}
          </div>
        </div>
        <div className="area" style={{height:(close?'auto':'')}}>
          {list.length > 0?  
            renderList(list,true)
          :
          <Row className="justify-content-center m-0"><Col xs="auto">
            Sem dados para mostrar
          </Col></Row>}
        </div>
      </div>
    </>;
  }

  return <>
    <div id="revenuse-area" className="pt-2">
      {close?
        ""
      :(
      <Row className="m-0">
        <Col md="2">
          <Form.Group>
            <Form.Label style={{color:"white"}}>Ano</Form.Label>
            <FormControl
              as="select"
              value={year}
              onChange={e => {
                setYear(e.target.value);
                setFilters({...filters, year:e.target.value})
              }}
              size="sm"
            >
              {(listYear).map((year, k) => (
                <option key={k}>
                  {year}
                </option>
              ))}
            </FormControl>
          </Form.Group>
        </Col>
        {/* <Col>
          <Form.Group>
            <Form.Label style={{color:"white"}}>Atividade</Form.Label>
            <Select
              closeMenuOnSelect={false}
              isMulti
              value={tasksSelected}
              options={
                [...tasks.map(group=>({
                    label:group.name,
                    options: [
                      ...group.tasks.map(task => ({
                        value:task.id,
                        label:task.name
                      }))
                    ]
                }))]
              }
              onChange={(selected) => setTasksSelected(selected?selected:[])}
            />
          </Form.Group>
        </Col> */}
      </Row>
      )}
      {close?'':
        renderLeft(list)
      }
      {renderRight(listSelected)}
    </div>
    {showModalCurrecy!=null?(
      <div id="show-modal-revenues-currecy">
        <div id="show-modal-revenues-currecy-body">
          <Alert variant="info">
          Você selecionou um item com valor em {showModalCurrecy.currency==2?"Dólar":"Euro"}, para adicionar precisa do valor em Real.
          </Alert>
          <div className="revenues-itens">
            <div className="revenues-itens-head row justify-content-between m-0">
              <div className="col p-0 m-0 align-self-center">
                {`${showModalCurrecy.type} #${showModalCurrecy.id}`}
              </div>
            </div>
            <div className="revenues-itens-body">
              <div className="row m-0">
                <div className="col p-1">
                  <div>{showModalCurrecy.service_provider}</div>
                  <div>{showModalCurrecy.description}</div>
                </div>
                <div className="col-auto align-self-center revenues-itens-currency p-1">
                  <div>{currencyFormat(showModalCurrecy.value, showModalCurrecy.currency)}</div>
                </div>
              </div>
            </div>
          </div>
          <Row className="mt-2">
            <Col>
              <Form.Group as={Row} className="mb-0" controlId="formPlaintextEmail">
                <Form.Label column sm="auto">
                  Valor em Real:
                </Form.Label>
                <Col>
                  <Currency
                    value={showModalCurrecy.realValue}
                    onChange={(e) => setShowModalCurrency({...showModalCurrecy, realValue: currencyReverse(e.target.value)})}
                    size="sm"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col xs="auto">
              <Button variant="success" size="sm" className="mr-1" 
                disabled={showModalCurrecy.realValue?false:true}
                onClick={()=>{
                  if(onChange){
                    onChange([...listSelected, showModalCurrecy]);
                    setLast(listSelected.length);
                    setShowModalCurrency(null);
                  }
                }}
              >
                Salvar
              </Button>
              <Button variant="danger" size="sm"
                onClick={()=>{
                  setShowModalCurrency(null);
                }}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    ):''}
  </>;
}

export default CreditCardFormRevenues;